import type {CollapsibleContentProps} from '@radix-ui/react-collapsible';

import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {CollapsibleContent} from '@radix-ui/react-collapsible';
import {Stack, SPACING_NONE} from '@travel-frontend/ui-components';

export const Content = styled(
  ({children, ...restProps}: CollapsibleContentProps) => (
    <CollapsibleContent {...restProps}>
      <Stack spacing={SPACING_NONE}>{children}</Stack>
    </CollapsibleContent>
  )
)(
  () => css`
    overflow: hidden;

    &[data-state='open'] {
      animation: slideDown 200ms ease-out;
    }

    &[data-state='closed'] {
      animation: slideUp 200ms ease-out;
    }

    @keyframes slideDown {
      from {
        height: 0;
      }
      to {
        height: var(--radix-collapsible-content-height);
      }
    }

    @keyframes slideUp {
      from {
        height: var(--radix-collapsible-content-height);
      }
      to {
        height: 0;
      }
    }
  `
);
